<template>
  <div class="result_search">
    <div class="header" ref="header">
      <div class="header-inner">
        <van-icon name="arrow-left" class="left-icon" @click="back" />
        <div class="search">
          <van-swipe v-show="inputValue == ''" :show-indicators="false" :vertical="true" :autoplay="words.length == 1 ? 0 : 5000"
            :touchable="false" @change="changeSwipe" ref="swipe" v-if="words.length > 1">
            <van-swipe-item v-for="(item,i) in words" :key="i">{{ item.app_name }}</van-swipe-item>
          </van-swipe>
          <input v-model="inputValue" type="text" class="search_ipt" @focus="handleFocus2" @blur="handleBlur"
            ref="search_ipt" :placeholder="placeholder">
          <i class="clear" @click="cleaript" v-if="showclear"></i>
          <button class="search_btn" @click="getSearch">搜索</button>
        </div>
      </div>
    </div>
    <!-- 历史记录 -->
    <div class="history" v-if="!is_search&&historyList.length > 0">
      <p class="note">
        <span>历史搜索</span>
        <button @click="empty">
          <van-icon class="icon" name="delete-o" />
        </button>
      </p>
      <div class="history-list" v-if="historyList.length > 0">
        <p v-for="(item, index) in historyList.slice(0, 10)" :key="index" @click="search(item)">
          {{ item }}
        </p>
      </div>
      <p v-else style="
          text-align: center;
          margin: 0 auto;
          font-size: 1.2rem;
          margin: 2rem 0;
          color: #727272;
        ">
        暂无搜索记录
      </p>
    </div>

    <div class="unsearch" v-if="!is_search">
      <ul class="navs" v-if="asideList.length > 0">
        <li class="nav_item" :class="{'active': aside_index == 0}" @click.stop="asideTarget(0)">
          推荐
        </li>
        <li class="nav_item" v-for="(item,i) in asideList" :key="i" :class="{'active': aside_index == i+1}"
          @click.stop="asideTarget(i+1)">
          {{ item.label.toUpperCase() }}
        </li>
      </ul>
      <div class="rec_list" ref="rec_list">
        <p id="rec" ref="rec">推荐</p>
        <ul>
          <li v-for="(it,k) in hotlist" :key="k" @click="goDetail(it.app_id)">
            <van-image :src="it.icon" />
            <p>{{ it.app_name }}</p>
          </li>
        </ul>
      </div>

      <div class="py">
        <div v-for="(item,i) in labelList" :key="i">
          <p class="label" :id="`label_`+item.label" v-if="item.type == 'label'" :ref="`label_`+ item.label">
            {{ item.label.toUpperCase() }}</p>
          <div class="game_box" v-else @click="goDetail(item.id)">
            <van-image class="icon" :src="item.icon" />
            <div class="name_num">
              <p class="name">{{ item.app_name }}</p>
              <div class="nums">
                <p class="name">共上架{{ item.goods_cnt }}件</p>
                <div class="trade_num">已成交<i>{{ item.trade_cnt }}</i>件</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="searched" v-if="is_search && show_result">
      <div v-if="search_result.length == 0" class="no_result">
        <img src="../../assets/bx/acc/no_goods.png" alt="">
        <p>没有找到相关游戏</p>
        <p>换个词搜搜看吧~</p>
      </div>
      <div class="has_result" v-else>
        <p class="total">共为您找到{{search_result.length}}款游戏 </p>
        <ul class="results">
          <li v-for="(item,i) in search_result" :key="i" class="game_box interest" @click="goDetail(item.id)">
            <van-image class="icon" :src="item.icon" />
            <div class="name_num">
              <p class="name">{{ item.app_name }}</p>
              <div class="nums">
                <p class="name">共上架{{ item.goods_cnt }}件</p>
                <div class="trade_num">已成交<i>{{ item.trade_cnt }}</i>件</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="interesting">
        <p class="tit">您可能感兴趣</p>
        <ul>
          <li v-for="(item,i) in hotlist" :key="i" class="game_box interest"  @click="goDetail(item.app_id)">
            <van-image class="icon" :src="item.icon" />
            <div class="name_num">
              <p class="name">{{ item.app_name }}</p>
              <div class="nums">
                <p class="name">共上架{{ item.goods_cnt }}件</p>
                <div class="trade_num">已成交<i>{{ item.trade_cnt }}</i>件</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="search_loading" v-if="search_loading">
      <van-loading type="spinner" size="3rem" />
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        words: [],
        words_index: 0,
        focus_ipt: false,
        inputValue: "",
        placeholder: '',
        showclear: false,

        hotlist: [], //推荐
        labelList: [], //首字母项目列表
        asideList: [], //字母列表
        aside_index: 0,
        touchable: false,
        historyList: JSON.parse(localStorage.getItem("historyList")) || [], //历史记录

        is_search: false, //是否搜索
        search_result: [],
        show_result: false,
        search_loading: false
      };
    },
    computed: {
      index() {
        return this.$route.query.index
      }
    },
    created() {},
    mounted() {
      var that = this
      this.getHotList();
      this.getappLabel()
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      //返回按钮
      back() {
        if(this.is_search) {
          this.show_result = false
          this.is_search = false
          this.focus_ipt = false
          this.inputValue = ''
          this.placeholder = ''
          return
        }
        this.$router.push({ name: 'index' })
      },
      cleaript() {
        this.show_result = false
        this.focus_ipt = true
        this.$refs.search_ipt.focus()
        this.inputValue = ''
        this.placeholder = ''
      },
      //搜索框里的placeholder轮播
      changeSwipe(index) {
        this.words_index = index
      },
      handleFocus2() {
        this.focus_ipt = true
        this.inputValue = ''
      },
      handleFocus() {
        if (this.placeholder != '') {
          return
        }
        if (this.inputValue == '') {
          this.focus_ipt = true
          this.inputValue = this.words[this.words_index].app_name
        }
      },
      handleBlur() {
        if (this.placeholder != '') {
          return
        }
        if (this.inputValue == '') {
          this.focus_ipt = false
        }
      },
      //获取推荐列表
      getHotList() {
        this.$Ajax("index/hot-apps", {}, "get").then((rs) => {
          if (rs.code == 200) {
            this.hotlist = rs.data.slice(0, 10)
            if(this.index) {
              this.words = [...rs.data.slice(0, 10).slice(this.index,10),...rs.data.slice(0, 10).slice(0,this.index)]
            }else {
              this.words = rs.data.slice(0, 10)
            }
          }
        });
      },
      //获取首字母项目列表接口
      getappLabel() {
        this.$Ajax('index/apps-by-label', {}, 'get').then(rs => {
          if (rs.code == 200) {
            this.labelList = this.changeArr(rs.data)
            this.asideList = this.labelList.filter(item => item.type == 'label')
          }
        })
      },
      //改造 首字母项目列表
      changeArr(arr) {
        if(arr.length == 0) return
        let array = arr.sort((a, b) => a.label.toUpperCase().localeCompare(b.label.toUpperCase()));
        array.splice(0, 0, {
          type: 'label',
          label: array[0].label
        })
        for (var i = 1; i < array.length; i++) {
          if (array[i].label && array[i - 1].label) {
            if (array[i - 1].label != array[i].label) {
              array.splice(i, 0, {
                type: 'label',
                'label': array[i].label
              })
            }
          }
        }
        return array
      },
      //点击侧边索引 跳转到对应位置
      asideTarget(i) {
        var that = this
        this.aside_index = i
        var header_top = this.$refs.header.clientHeight
        if (i == 0) {
          var top = this.$refs.rec.offsetTop
        } else {
          var top = this.$refs['label_' + that.asideList[i - 1].label][0].offsetTop
        }
        this.touchable = true
        setTimeout(() => {
          this.touchable = false
        }, 550)
        $('body,html').animate({
          scrollTop: top - header_top - 15
        }, 500)
      },
      //滚动到想要位置 侧边索引改变
      handleScroll() {
        if (this.touchable) return
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var header_top = this.$refs.header.clientHeight
        var top = this.$refs.rec_list.offsetTop + this.$refs.rec_list.clientHeight - header_top - 30
        if (scrollTop >= 0 && scrollTop < top) {
          this.aside_index = 0
        } else {
          for (var i = 0; i < this.asideList.length; i++) {
            if (i == this.asideList.length - 1) {
              if (scrollTop >= this.$refs['label_' + this.asideList[i].label][0].offsetTop - header_top - 30) {
                this.aside_index = i + 1
              }
            } else {
              if (scrollTop >= this.$refs['label_' + this.asideList[i].label][0].offsetTop - header_top - 30 &&
                scrollTop < this.$refs['label_' + this.asideList[i + 1].label][0].offsetTop - header_top - 30) {
                this.aside_index = i + 1
              }
            }
          }
        }
      },

      getSearch() {
        //历史
         if(this.inputValue.trim() == '' && this.focus_ipt) {
          this.inputValue = ''
          this.$toast("请输入搜索内容");
          return false;
        } else {
          if(this.inputValue == '' && this.placeholder == '') {
            this.handleFocus()
          }
          const maxlength = 10;
          const inputValueIndex = this.historyList.indexOf(this.inputValue);

          if (inputValueIndex === -1) {
            this.historyList.unshift(this.inputValue);
          } else {
            this.historyList.splice(inputValueIndex, 1);
            this.historyList.unshift(this.inputValue);
          }

          if (this.historyList.length > maxlength) {
            this.historyList = this.historyList.slice(0, maxlength);
          }

          localStorage.setItem("historyList", JSON.stringify(this.historyList));

          this.search(this.inputValue)
        }
      },
      search(keyword) {
        this.inputValue = keyword
        this.is_search = true
        this.search_loading = true
        this.$Ajax('index/serach',{keyword},'post').then(rs => {
          if(rs.code == 200) {
            this.search_result = rs.data
          }else {
            this.search_result = []
            setTimeout(() => {
              this.search_loading = false
            },1000)
            setTimeout(() => {
              this.show_result = true
            },1500)
          }
        }).finally(() => {
          setTimeout(() => {
            this.search_loading = false
          },1000)
          setTimeout(() => {
            this.show_result = true
          },1500)
        })
      },
      empty() {
        // 清空历史搜索记录
        localStorage.removeItem("historyList");
        this.historyList = [];
      },
      goDetail(id) {
        this.$router.push({
          path: "/detail",
          query: {
            app_id: id,
          },
        });
      },
    },
    watch: {
      inputValue: {
        immediate: true,
        handler(e) {
          if (e != '') {
            this.showclear = true
          } else {
            this.showclear = false
            this.is_search = false
          }
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    },
  };
</script>

<style scoped lang="less">
  .header {
    width: 100%;
    height: 7.4rem;
    position: fixed;
    top: 0;
    left: 50%;
    width: 100%;
    padding: 2rem 1rem 1rem;
    max-width: 525px;
    z-index: 100;
    transform: translateX(-50%);
    text-align: center;
    overflow: hidden;
    background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
    background-color: #fff;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1rem;
      background-color: #fff;
      border-top-left-radius: .4rem;
      border-top-right-radius: .4rem;
    }

    .header-inner {
      display: flex;
      align-items: center;
      position: relative;

      .left-icon {
        color: #ffff;
        font-size: 2rem;
        margin-right: .9rem;
        cursor: pointer;
      }

      .search {
        flex: 1;
        height: 3.4rem;
        background-color: #fff;
        border-radius: 10rem;
        overflow: hidden;
        position: relative;

        .van-swipe {
          width: 24rem;

          .van-swipe-item {
            padding-top: 0.8rem;
            font-size: 1.4rem;
            color: #999;
            text-align: left;
            padding-left: 1.5rem;
          }
        }

        .search_ipt {
          position: absolute;
          height: 100%;
          line-height: 3.4rem;
          width: 27rem;
          left: 0;
          top: 0;
          border: none;
          outline: none;
          background-color: transparent;
          padding: 0 1.5rem;
          font-size: 1.4rem;
          color: #000;
          &::placeholder {
            color: #999;
          }
        }

        .clear {
          position: absolute;
          right: 6.2rem;
          top: 50%;
          transform: translateY(-50%);
          width: 1.4rem;
          height: 1.4rem;
          border-radius: 50%;
          background-color: #a4a4a4;
          cursor: pointer;

          &::before,
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 1rem;
            height: .1rem;
            background-color: #fff;
          }

          &::before {
            transform: translate(-50%, -50%) rotate(45deg);
          }

          &::after {
            transform: translate(-50%, -50%) rotate(-45deg);
          }
        }

        .search_btn {
          position: absolute;
          right: .5rem;
          top: 50%;
          transform: translateY(-50%);
          width: 5.3rem;
          height: 2.6rem;
          line-height: 2.6rem;
          background-color: #f66f30;
          border-radius: 10rem;
          color: #fff;
          font-size: 1.4rem;
          border: none;
          outline: none;

          &:active {
            opacity: 0.9;
          }
        }
      }

    }
  }

  .result_search {
    padding-top: 7.4rem;
    position: relative;
  }

  .history {
    padding-top: 1rem;

    .banner {
      margin: 1rem;

      img {
        width: 100%;
        height: auto;
      }
    }

    // background-color: palegoldenrod;
    .note {
      display: flex;
      justify-content: space-between;
      margin: 0 1rem;
      color: #555;

      span {
        font-size: 1.4rem;
        font-weight: 700;
        font-family: Source Han Sans CN, Source Han Sans CN;
      }

      button {
        background-color: unset;
        border: none;
        text-align: center;

        .van-icon {
          color: #7a7a7a;
          font-size: 1.4rem;
        }
      }
    }

    .history-list {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2rem;

      p {
        text-align: center;
        padding: 0.8rem 1.5rem;
        margin: 0.8rem;
        background: rgba(233, 233, 233, 0.5);
        border-radius: .4rem;
        color: #727272;
        font-size: 1.2rem;
        cursor: pointer;
      }
    }
  }

  .rec_list {
    margin: 0 1rem;
    padding: 1rem;
    background: url(../../assets/version_1.3.0/search/rec_bg.png) no-repeat 0 0 /100% 22.8rem;

    #rec {
      padding: 0;
      font-size: 1.4rem;
      color: #F66F30;
      font-weight: 700;
      margin-left: .3rem;
      line-height: unset;
      margin-bottom: 1.9rem;
    }

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin-right: 1.2rem;
        margin-bottom: 1.6rem;
        cursor: pointer;

        &:nth-child(5n) {
          margin-right: 0;
        }

        .van-image {
          width: 5.7rem;
          height: 5.7rem;
          border-radius: 1rem;
          overflow: hidden;
        }

        p {
          margin-top: 0.3rem;
          text-align: center;
          max-width: 5.7rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 1.2rem;
          line-height: 1.2;
          color: #606060;
          height: 2.8rem;
        }
      }
    }
  }

  .py {
    .label {
      padding: 0 1rem .9rem;
      font-size: 1.6rem;
      color: #a4a4a4;
      font-weight: 700;
    }
  }

  .game_box {
    display: flex;
    margin: 0 2.8rem 1.4rem 2rem;
    cursor: pointer;
    &.interest {
      margin: 0 0 1.2rem;
    }
    .icon {
      width: 5.4rem;
      height: 5.4rem;
      margin-right: .8rem;
      border-radius: 1rem;
      overflow: hidden;
    }

    .name_num {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: .5rem 0;

      .name {
        font-size: 1.4rem;
        color: #000;
      }

      .nums {
        display: flex;
        justify-content: space-between;
        font-size: 1.2rem;
        color: #929292;

        p {
          font-size: 1.2rem;
          color: #929292;
        }

        i {
          color: #FF5E5E;
        }
      }
    }
  }

  .navs {
    position: fixed;
    top: 60%;
    left: calc(50% + 16.2rem);
    transform: translateY(-50%);

    .nav_item {
      padding: .5rem 0;
      font-size: 1.2rem;
      color: #a4a4a4;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2rem;
      margin-bottom: .25rem;
      cursor: pointer;
      a {
        font-size: 1.2rem;
        color: #a4a4a4;
      }

      &.active {
        color: #fff;
        background-color: #FF5E5E;
        border-radius: 10rem;

        a {
          color: #fff;
        }
      }
    }
  }

  .no_result {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3rem 0 2.7rem;
    img {
      width: 18.1rem;
      height: 11.6rem;
    }
    p {
      font-size: 1.4rem;
      color: #999;
      line-height: 1.5;
    }
  }
  .interesting {
    margin: 0 1rem 3rem;
    padding: 1.3rem 1rem;
    border: 1px solid #f66f30;
    border-radius: .8rem;
    background: linear-gradient( 180deg, rgba(252, 190, 160,0.5) 0%, rgba(255, 255, 255,0) 10rem);
    .tit {
      font-size: 1.4rem;
      color: #F66F30;
      font-weight: 700;
      margin-bottom: 1.6rem;
      font-family: Source Han Sans CN, Source Han Sans CN;
    }
  }
  .has_result {
    .total {
      padding: 1rem 1rem 0;
      font-size: 1.2rem;
      color: #929292;
    }
    .results {
      margin: 0 1rem;
      padding: 1rem;
    }
  }


  .search_loading {
    .van-loading {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 100000;
        display: flex;
        align-items: center;
        justify-content: center;
        .van-loading__spinner {
            color: #666;
        }
    }
}
</style>